import types from '../../../helpers/textureTypes';
import Back from '../Back';
import Content from '../Content';
import styles from './Configuration.module.scss';
import { useForm } from 'react-hook-form';
import { useSelector } from 'react-redux';

const typeOptions = [types.FLOAT, types.HALF_FLOAT, types.UNSIGNED_BYTE];
const filterOptions = [types.LINEAR, types.NEAREST];

const Item = ({ register, typeName, filterName }) => {
  return (
    <div className={styles.items}>
      <div className={styles.item}>
        <label>Texture type</label>
        <select {...register(typeName)}>
          {typeOptions.map((item) => (
            <option value={item} key={item}>
              {item}
            </option>
          ))}
        </select>
      </div>
      <div className={styles.item}>
        <label>Texture filtering</label>
        <select {...register(filterName)}>
          {filterOptions.map((item) => (
            <option value={item} key={item}>
              {item}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

const setDefaultValues = (data) => {
  const keys = Object.keys(data);

  for (let i = 0; i < keys.length; i++) {
    localStorage.setItem(keys[i], data[keys[i]]);
  }
};

const Configuration = () => {
  const currentValues = useSelector((state) => state.configuration.data);

  const { register, handleSubmit } = useForm({
    defaultValues: currentValues,
  });

  const onSubmit = (data) => {
    // eslint-disable-next-line no-restricted-globals
    if (confirm('App will be reloaded. Are you sure?') === true) {
      setDefaultValues(data);

      const url = window.location.href;
      window.location.href = url;
    }
  };

  return (
    <>
      <Back title="Configuration" />

      <Content>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className={styles.row}>
            <div className={styles.header}>
              <span>Sizes</span>
            </div>

            <div className={styles.items}>
              <div className={styles.item}>
                <label>Max Texture Size:</label>
                <select {...register('maxTextureSize')}>
                  <option value={1024}>1024</option>
                  <option value={2048}>2048</option>
                  <option value={3840}>3840</option>
                  <option value={4096}>4096</option>
                </select>
              </div>
            </div>
          </div>

          <div className={styles.group}>
            <div className={styles.header}>
              <span>Single Layer Brush</span>
            </div>

            <Item register={register} typeName="singleBrushTexturesType" filterName="singleBrushTexturesFilter" />
          </div>

          <div className={styles.group}>
            <div className={styles.header}>
              <span>Double Layer Brush</span>
            </div>

            <Item register={register} typeName="doubleBrushTexturesType" filterName="doubleBrushTexturesFilter" />
          </div>

          <div className={styles.group}>
            <div className={styles.header}>
              <span>Triple Layer Brush</span>
            </div>

            <Item register={register} typeName="tripleBrushTexturesType" filterName="tripleBrushTexturesFilter" />
          </div>

          <div className={styles.group}>
            <div className={styles.header}>
              <span>Velocities</span>
            </div>

            <Item register={register} typeName="brushVelocitiesTexturesType" filterName="brushVelocitiesTexturesFilter" />
          </div>

          <div className={styles.group}>
            <div className={styles.header}>
              <span>Splat</span>
            </div>

            <Item register={register} typeName="splatTexturesType" filterName="splatTexturesFilter" />
          </div>

          <div className={styles.row}>
            <div className={styles.header}>
              <span>Random texture</span>
            </div>

            <div className={styles.items}>
              <div className={styles.item}>
                <label>Texture filtering:</label>
                <select {...register('randomTexturesFilter')}>
                  {filterOptions.map((item) => (
                    <option value={item} key={item}>
                      {item}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>

          <div className={styles.row}>
            <div className={styles.header}>
              <span>Layers</span>
            </div>

            <div className={styles.items}>
              <div className={styles.item}>
                <label>Start app with:</label>
                <select {...register('howManyLayers')}>
                  <option value={1}>1 layer</option>
                  <option value={2}>2 layers (base + mantis)</option>
                  <option value={3}>3 layers (x + y + z)</option>
                </select>
              </div>
            </div>
          </div>

          <div className={styles.submitWrapper}>
            <input type="submit" className={styles.submit} value="Save and restart" />
          </div>
        </form>
      </Content>
    </>
  );
};

export default Configuration;
